import React, { useMemo } from 'react';
import { SERVICES, EXTRAS } from './ServiceSelector';

export default function BookingSummary({ data }){
  const { serviceId='basic', extras=[], vehicle={}, date, time, contact={}, mobileOrDropoff } = data;

  const price = useMemo(() => {
    const s = SERVICES.find(s => s.id === serviceId);
    const base = s ? s.price : 0;
    const extrasTotal = extras.reduce((sum, id) => {
      const x = EXTRAS.find(e => e.id === id);
      return sum + (x ? x.price : 0);
    }, 0);
    return base + extrasTotal;
  }, [serviceId, extras]);

  return (
    <div className="booking-summary">
      <h3>Summary</h3>
      <ul>
        <li><strong>Service:</strong> {SERVICES.find(s => s.id === serviceId)?.name} </li>
        {extras.length > 0 && (
          <li><strong>Add-ons:</strong> {extras.map(id => EXTRAS.find(e => e.id === id)?.name).join(', ')}</li>
        )}
        <li><strong>Type:</strong> {mobileOrDropoff === 'mobile' ? 'Mobile service' : 'Shop drop-off'}</li>
        <li><strong>Vehicle:</strong> {vehicle.year} {vehicle.make} {vehicle.model}</li>
        <li><strong>Date & Time:</strong> {date} @ {time}</li>
        <li><strong>Name:</strong> {contact.name}</li>
        <li><strong>Phone:</strong> {contact.phone}</li>
        <li><strong>Email:</strong> {contact.email}</li>
      </ul>
      <div className="total">Total: ${price}</div>
      <p className="muted">You can pay in full or place a deposit at checkout.</p>
    </div>
  );
}
